import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MyRangeInput from '../../MyRangeInput'


export default function HelpSettingPreferences(props){
  const [rangeValue, setRangeValue] = useState(4)
  const [rangeValue2, setRangeValue2] = useState(7)

  return (
      <div>
        <p>
          {"Each Slider represnts how much the relevent field is important to you."}
        </p>
        <div className="py-2 container-fluid prefernces-item prefernceNode">
          {/*<span className={"tollip"}>
            {nodeRepsentation.description}
          </span>*/}
          <div className="row">
            <div className="col-md-3 col-sm-12 px-0   node-title justify-content-center" align="center" style={{
                overflow: "hidden"
              }}>
                  <span  className="title">
                    {"Reviews"}
                  </span>
            </div>
            <div className="col-md-9 col-sm-12 " style={{
                display: 'inline-block'
              }}>
              <span className="slider-icon none-sm" >
                <i class="fas fa-users" aria-hidden="true"></i>
              </span>
              <MyRangeInput label={""} value={rangeValue} color={"lightblue"}  onChange={setRangeValue}/>
            </div>
          </div>
        </div>

        <div className="pt-2 pb-4 container-fluid prefernces-item prefernceNode">
          {/*<span className={"tollip"}>
            {nodeRepsentation.description}
          </span>*/}
          <div className="row">
            <div className="col-md-3 col-sm-12 px-0   node-title justify-content-center" align="center" style={{
                overflow: "hidden"
              }}>
                  <span  className="title">
                    {"Price"}
                  </span>
            </div>
            <div className="col-md-9 col-sm-12 " style={{
                display: 'inline-block'
              }}>
              <span className="slider-icon none-sm" >
                <i class="fas fa-money-bill-wave" aria-hidden="true"></i>>
              </span>
              <MyRangeInput label={""} value={rangeValue2} color={"rgb(65, 179, 163)"}  onChange={setRangeValue2}/>
            </div>
          </div>
        </div>
        <b> What is important is the proportion between the values.  <br/> Think how much you care about each aspect compared to the others</b> <br/><br/>
        Lets look on a phone that has perfect reviews all around the web and gets a score of 100 in Reviews.
        The Phone is also preety expansive, so it gets a Price score of 20.
        Given the values above the Phones score will be:<br/>
        <div className="py-3" style={{textAlign:"center"}}> <strong> {`\nPhone Score: ${Math.round((rangeValue/(rangeValue + rangeValue2)) * 100 + (rangeValue2/(rangeValue + rangeValue2)) * 20 )}`}</strong>  </div>
        <div className="py-3" style={{textAlign:"center"}}> <strong> {`${(rangeValue/(rangeValue + rangeValue2)).toPrecision(2)} * ${100} + ${(rangeValue2/(rangeValue + rangeValue2)).toPrecision(2)} * ${20}`}</strong>  </div>
      </div>);
}
